<div>
  <div class="card-header" fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="space-between center">
    <label>{{label}}</label>
    <button class="dialog-button" mat-icon-button [matTooltip]="'ACTIONS.CLOSE'| translate" (click)="onCloseBtnClick()" matTooltipShowDelay="2000" (mouseenter)="isRed = true" (mouseleave)="isRed = false">
      <mat-icon class="dialog-button-icon" [@redBold]="isRed ? 'red' : 'normal'">close</mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>
</div>
